import { utils, writeFile } from 'xlsx';
import { shipmentsExcelMapping } from './shipments-excel-mapping';

export const generateShipmentsTemplate = () => {
  // The superadmin importer needs an explicit season/species for every row.
  const headers = [
    'Temporada',
    'ID Especie',
    ...Object.keys(shipmentsExcelMapping),
  ];
  const base: Record<string, string | number> = {
    Temporada: '2025-2026',
    'ID Especie': 2,
    Cliente: 'CLIENTE1',
    Nave: 'NAVE1',
    'Tipo Nave': 'M',
    'Fecha Despacho Packing': '2025-11-01',
    'Fecha ETD': '2025-11-05',
    'Fecha ETA': '2025-12-05',
    'Cantidad de Cajas': 100,
    'Variedad Real': 'SANTINA',
    'Variedad Etiquetada': 'SANTINA',
    Calibre: '2J',
    Color: 'D',
    Etiqueta: 'DRAGON',
    'Peso Caja': 5,
    'Código Embalaje': 'CATR18',
    'Nombre Productor': 'PRODUCTOR1',
    Categoría: 'CAT1',
  };
  const examples: Record<string, string | number>[] = [
    {
      ...base,
      Referencia: 'REF001',
      Contenedor: 'TEST1234567',
      Pallet: 'PALLET-1',
    },
    {
      ...base,
      Referencia: 'REF001',
      Contenedor: 'TEST1234567',
      Pallet: 'PALLET-2',
    },
    {
      ...base,
      Referencia: 'REF002',
      Contenedor: 'TEST7654321',
      Pallet: 'PALLET-3',
    },
  ];
  const worksheet = utils.aoa_to_sheet([
    headers,
    ...examples.map((row) => headers.map((header) => row[header] ?? '')),
  ]);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Despachos');
  writeFile(workbook, 'plantilla-despachos.xlsx');
};
